<template>
  <div id="main-content" class="parent-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToAddParent">+ {{ $t('parent_list.add_parent') }}</el-button>
            <el-button type="primary" @click="sendMailAll">{{ $t('parent_list.send_mail_all') }}</el-button>
            <el-button  type="success" @click="sendMailAgentAll">{{ $t('parent_list.send_mail_agent_all') }}</el-button>
<!--            <el-button type="primary" @click="exportData" plain>{{ $t('common.export_excel') }}</el-button>-->
            <el-button type="warning" @click="openListApprove">{{ $t('parent_list.parent_list_approve') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <template v-if="data">
        <el-row style="padding-top: 20px">
          <table class="bus-list filter-sort-table">
            <tr>
              <th width="5%">#</th>
              <th width="12%" class="input-th">
                <el-input :placeholder="$t('common.full_name')" v-model="filter.name"></el-input>
                <Sort :model="sort.name" @change="changeSort($event, 'name')"></Sort>
              </th>
              <th width="13%" class="input-th">
                <el-input :placeholder="$t('common.email')" v-model="filter.email"></el-input>
                <Sort :model="sort.email" @change="changeSort($event, 'email')"></Sort>
              </th>
              <th width="10%" class="input-th">
                <el-input :placeholder="$t('common.phone')" v-model="filter.phone"></el-input>
                <Sort :model="sort.phone" @change="changeSort($event, 'phone')"></Sort>
              </th>
              <th width="8%" class="input-th">
                <el-select v-model="filter.gender" :placeholder="$t('common.gender')">
                  <el-option :label="$t('common.gender')" value=""></el-option>
                  <el-option :label="$t('common.female')" :value="0"></el-option>
                  <el-option :label="$t('common.male')" :value="1"></el-option>
                </el-select>
                <Sort :model="sort.gender" @change="changeSort($event, 'gender')"></Sort>
              </th>
              <th width="10%" class="input-th">
                <el-select v-model="filter.is_member">
                  <el-option :label="$t('common.member')" value=""></el-option>
                  <el-option :label="$t('common.no')" :value="0"></el-option>
                  <el-option :label="$t('common.yes')" :value="1"></el-option>
                </el-select>
                <Sort :model="sort.is_member" @change="changeSort($event, 'is_member')"></Sort>
              </th>
              <th width="8%" class="input-th">
                <el-select v-model="filter.is_sent_mail">
                  <el-option :label="$t('common.sent_mail')" value=""></el-option>
                  <el-option :label="$t('common.no')" :value="0"></el-option>
                  <el-option :label="$t('common.yes')" :value="1"></el-option>
                </el-select>
                <Sort :model="sort.is_sent_mail" @change="changeSort($event, 'is_sent_mail')"></Sort>
              </th>
              <th width="8%" class="input-th">
                <el-select v-model="filter.is_active">
                  <el-option :label="$t('common.active')" value=""></el-option>
                  <el-option :label="$t('common.no')" :value="0"></el-option>
                  <el-option :label="$t('common.yes')" :value="1"></el-option>
                </el-select>
                <Sort :model="sort.is_active" @change="changeSort($event, 'is_active')"></Sort>
              </th>
              <th width="8%" class="input-th">
                {{ $t('common.status')}}
              </th>
              <th>
                <el-button @click="resetFilter"
                   style="margin: 2px;" type="danger">{{ $t('common.reset') }}
                </el-button>
              </th>
            </tr>
            <tr v-for="(parent, index) in data.data" :key="parent.id">
              <td>{{ data.from + index }}</td>
              <td>{{ parent.name }}</td>
              <td>{{ parent.email }}</td>
              <td>{{ parent.phone }}</td>
              <td v-if="parent.gender === 0">{{ $t('common.female') }}</td>
              <td v-else>{{ $t('common.male') }}</td>
              <td v-if="parent.is_member === 1">{{ $t('common.yes') }}</td>
              <td v-else>{{ $t('common.no') }}</td>
              <td v-if="parent.is_sent_mail === 1">{{ $t('common.yes') }}</td>
              <td v-else>{{ $t('common.no') }}</td>
              <td>{{ parent.is_active ? $t('common.yes') : $t('common.no') }}</td>
              <td>{{ renderStatus(parent.authorized_mail_status) }}</td>
              <td>
                <b-button variant="outline-success" @click="sendMail(parent.id)" style="margin-right: 10px">
                  {{ $t('parent_list.send_mail') }}
                </b-button>

                <b-button variant="outline-primary" @click="goToDetailParent(parent.id)" style="margin-right: 10px">
                  {{ $t('common.detail') }}
                </b-button>
                <b-button variant="danger" @click="deleteParent(parent.id)">{{ $t('common.delete') }}</b-button>
                <b-button v-if="parent.authorized_mail_status !== CANNOT_SEND" variant="outline-primary" @click="sendMailAgent(parent.id)" style="margin-top: 5px">
                  {{ $t('parent_list.send_agent_all') }}
                </b-button>
              </td>
            </tr>
          </table>
        </el-row>
        <el-row style="padding-top: 15px">
          <el-pagination
            v-show="data.total > data.per_page"
            background
            @current-change="didSelectPage"
            :page-size="data.per_page"
            layout="prev, pager, next"
            :current-page="page"
            :total="data.total">
          </el-pagination>
        </el-row>
      </template>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import Sort from '@/components/Sort'
  import { downloadFileFromBlob } from '@/utils'
  import {CANNOT_SEND, NEED_SEND, NOT_YET_SEND} from "../../config";

  export default {
    name: 'ParentList',
    components: {
      PageTitle,
      Sort
    },
    data: function () {
      return {
        backLink: ``,
        title: 'parent_list.parent_list',
        page: 1,
        CANNOT_SEND: CANNOT_SEND,
        filter: {
          name: '',
          email: '',
          phone: '',
          gender: '',
          is_member: '',
          is_sent_mail: '',
          is_active: ''
        },
        sort: {
          name: null,
          email: null,
          phone: null,
          gender: null,
          is_member: null,
          is_sent_mail: null,
          is_active: null
        },
        isBack: false,
        data: null,
        filterTimeout: null
      }
    },
    methods: {
      openListApprove(){
        this.$router.push('/list-parent-need-approve')
      },
      sendMail(parentId) {
        this.$store.commit('openConfirm', {
          title: this.$t('parent_list.send_mail'),
          message: this.$t('parent_list.parent_send_mail_confirm'),
          callback: () => {
            let payload = {
              parent_id: parentId,
              successCallback: () => {
                this.data.data.forEach((item) => {
                  if (item.id === parentId) {
                    item.is_sent_mail = 1
                  }
                })
              }
            }

            this.$store.dispatch('parent/sendMail', payload)
          }
        })
      },
      renderStatus(status){
        if(status === CANNOT_SEND){
          return this.$t('moreLanguage.cannot_send')
        }else if(status === NOT_YET_SEND){
          return this.$t('moreLanguage.not_yet_send')
        }else if(status === NEED_SEND){
          return this.$t('moreLanguage.need_send')
        }else{
          return this.$t('moreLanguage.sent')
        }
      },
      sendMailAgent(parentId){
        this.$store.commit('openConfirm', {
          title: this.$t('parent_list.send_mail'),
          message: this.$t('parent_list.send_mail_agent_person_confirm'),
          callback: () => {
            let payload = {
              data: {
                parent_id: parentId
              },
              successCallback: () => {
                this.$store.commit('openNotification', {
                  type: 'success',
                  message: this.$t('parent_list.send_mail_success')
                })
              }
            }

            this.$store.dispatch('parent/sendMailAgentPerson', payload)
          }
        })
      },
      sendMailAll: function () {
        this.$store.commit('openConfirm', {
          title: this.$t('parent_list.send_mail_all'),
          message: this.$t('parent_list.parent_send_mail_all_confirm'),
          callback: () => {
            let payload = {
              successCallback: () => {
                this.data.data.forEach((item) => {
                  item.is_sent_mail = 1
                })
              }
            }

            this.$store.dispatch('parent/sendMailAll', payload)
          }
        })
      },
      sendMailAgentAll: function () {
        this.$store.commit('openConfirm', {
          title: this.$t('parent_list.send_mail_all'),
          message: this.$t('parent_list.send_mail_agent_all_confirm'),
          callback: () => {
            let payload = {
              successCallback: () => {
                this.$store.commit('openNotification', {
                  type: 'success',
                  message: this.$t('parent_list.send_mail_success')
                })
                this.retrieveData()
              }
            }

            this.$store.dispatch('parent/sendMailAgentAll', payload)
          }
        })
      },
      goToAddParent: function () {
        this.saveState()
        this.$router.push('/parent/add')
      },
      goToDetailParent(parentId) {
        this.saveState()
        this.$router.push({path: '/parent/detail', query: {pid: parentId}});
      },
      saveState: function () {
        this.$store.commit('parent/updateState', {
          filter: this.filter,
          sort: this.sort,
          page: this.page
        })
      },
      didSelectPage: function (e) {
        this.page = e
        this.retrieveData()
      },
      deleteParent(parentId) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('parent_list.parent_delete_confirm'),
          callback: () => {
            let payload = {
              parent_id: parentId,
              successCallback: () => {
                if (this.data.data.length <= 1) {
                  this.page = this.page > 1 ? this.page - 1 : 1
                }

                this.retrieveData()
              }
            }

            this.$store.dispatch('parent/deleteParent', payload)
          }
        })
      },
      resetFilter: function () {
        this.filter = Object.assign({}, {
          name: '',
          email: '',
          phone: '',
          gender: '',
          is_member: '',
          is_sent_mail: '',
          is_active: ''
        })

        this.sort = Object.assign({}, {
          name: null,
          email: null,
          phone: null,
          gender: null,
          is_member: null,
          is_sent_mail: null,
          is_active: null
        })
      },
      changeSort (type, field) {
        this.sort[field] = type
        this.sort = Object.assign({}, this.sort)
        this.retrieveData()
      },
      // exportData: function () {
      //   let successCallback = (response) => {
      //     let name = `parents_${this.$moment().format('YYYYMMDD')}`
      //     let type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      //     downloadFileFromBlob (response.data, type, name, 'xlsx')
      //   }
      //
      //   this.$store.dispatch('parent/exportParents', { successCallback })
      // },
      retrieveData: function () {
        let filter = this.filter
        let sort = this.sort
        let page = this.page
        let successCallback = (response) => {
          this.data = Object.assign({}, response.data.data)
        }

        this.$store.dispatch('parent/retrieveParentList', {
          filter, sort, page, successCallback
        })
      },
    },
    created: function () {
      if (this.$route.query.action && this.$route.query.action === "back") {
        if (this.currentFilter) {
          this.filter = Object.assign({}, this.currentFilter)
          this.isBack = true
        }

        if (this.currentSort) {
          this.sort = Object.assign({}, this.currentSort)
        }

        if (this.currentPage) {
          this.page = this.currentPage
        }
      }

      this.$store.commit('parent/updateState', {
        filter: null,
        sort: null,
        page: null
      })
    },
    mounted: function () {
      this.retrieveData()
    },
    computed: {
      ...mapState('parent', ['currentFilter', 'currentSort', 'currentPage'])
    },
    watch: {
      filter: {
        deep: true,
        handler: function () {
          if (this.isBack) {
            this.isBack = false
            return
          }

          clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            this.retrieveData()
          }, 1000)

          this.page = 1
        }
      }
    }
  }
</script>
<style lang="scss">
  .bus-list {
    width: 100%;
    /*border: 1px solid #DCDFE6;*/
  }

  table, th, td {
    border: 1px solid #DCDFE6;
    border-collapse: collapse;
  }

  th {
    height: 55px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
  }

  td {
    height: 40px;
  }
</style>
